import { client } from "@services/apollo-client";

import { createDummyStore } from "@graphql/mutations/store/create-dummy-store";
import { updateDummyStore } from "@graphql/mutations/store/update-dummy-store";
import { publishDummyStore } from "@graphql/mutations/store/publish-dummy-store";

export const createUserDummyStore = async (payload) => {
  const { data } = await client.mutate({
    mutation: createDummyStore,
    variables: { input: { ...payload } },
  });
  return data?.createDummyStore;
};

export const updateUserDummyStore = async (payload) => {
  const { data } = await client.mutate({
    mutation: updateDummyStore,
    variables: { input: { ...payload } },
  });
  return data?.updateDummyStore;
};

export const publishUserDummyStore = async (payload) => {
  const { data } = await client.mutate({
    mutation: publishDummyStore,
    variables: { input: { ...payload } },
  });
  return data?.publish?.response;
};
